// extracted by mini-css-extract-plugin
export default {"container":"r1-z","list":"s1-z"};